import pictureFallback from "../../asset/images/picture_fallback.png";
export const employeeFallback = {
  ern: "E000000",
  name: "[NMS User]",
  role: "Administrator",
  picture: pictureFallback,
};
